export const COLLECTIONS = {
  LINKS: 'PilgrimGuideLinks',
  PILGRIMS: 'Pilgrims',
  GUIDES: 'Guides',
  ORGANIZERS: 'Organizers',
  DISPUTES: 'Disputes',
  GUIDE_BANS: 'GuideBans',
  BANS: 'Bans'
} as const;

const LINK_STATUS = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
  DISPUTED: 'disputed',
  PENDING: 'pending'
} as const;

const DISPUTE_STATUS = {
  PENDING: 'pending',
  UNDER_PROCESSING: 'under_processing',
  RESOLVED: 'resolved'
} as const;